import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Eye — slow blink + pupil dilation.
 *  The almond outline shrinks vertically for the blink (keyframed on
 *  stroke-dasharray would be wrong since the path is a complete loop, so
 *  we clip the pupil instead with a radius contraction; gives a clean
 *  "eyelid closing" impression in 16×16). */
export function IcnEye(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="eye">
      <path d="M1.5 8S4 4 8 4s6.5 4 6.5 4-2.5 4-6.5 4S1.5 8 1.5 8z">
        {animate && (
          <animate
            attributeName="d"
            values="
              M1.5 8S4 4 8 4s6.5 4 6.5 4-2.5 4-6.5 4S1.5 8 1.5 8z;
              M1.5 8S4 4 8 4s6.5 4 6.5 4-2.5 4-6.5 4S1.5 8 1.5 8z;
              M1.5 8S4 7.5 8 7.5s6.5 0.5 6.5 0.5-2.5 0.5-6.5 0.5S1.5 8 1.5 8z;
              M1.5 8S4 4 8 4s6.5 4 6.5 4-2.5 4-6.5 4S1.5 8 1.5 8z;
              M1.5 8S4 4 8 4s6.5 4 6.5 4-2.5 4-6.5 4S1.5 8 1.5 8z
            "
            keyTimes="0;0.46;0.5;0.54;1"
            dur="5s"
            repeatCount="indefinite"
          />
        )}
      </path>
      <circle cx="8" cy="8" r="2" fill="currentColor" stroke="none">
        {animate && (
          <animate
            attributeName="r"
            values="2;2;0.2;2;2;2"
            keyTimes="0;0.45;0.5;0.55;0.7;1"
            dur="5s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      <circle cx="8.6" cy="7.4" r="0.5" fill="var(--vq-paper-raised, #fff)" stroke="none">
        {animate && (
          <animate
            attributeName="opacity"
            values="1;1;0;1;1"
            keyTimes="0;0.46;0.5;0.54;1"
            dur="5s"
            repeatCount="indefinite"
          />
        )}
      </circle>
    </Svg>
  );
}
